<template>
<router-link class="featured-item" :to="to">

      <div class="flex-box">
      <h2 class="title">{{title}}</h2>
    </div>
     <ratio-image class="poster-image" v-if="image_src" :src="image_src" :style="computePosterStyle"/>
     <div class="text-container">
      
       <div class="text" v-if="text">
            {{text}}
           
        </div>
    </div>
    <div class="clear-float"></div>
     <div v-if="readMore" class="lees-meer">{{$t('language.lees_meer')}}</div>
    </router-link>
</template>

<script>

import RatioImage from '../RatioImage.vue';

export default {
  name: 'featured-album-item',
  props:{
    to:{default:"/"},
    title:{default:undefined},
    text:{default:undefined},
    image_src:{default:undefined},
    readMore:{default:false},
    index:{default:0},
  },
  data:function(){
    return {
    }
  },
  components:{
    RatioImage,
  },
  methods:{
  },
  computed:{
    
    computePosterStyle(){
      if(this.index==0){
        // big news poster
        //return {width:'100%!important',marginBottom:'10px!important'}
      }
      return {};
    }
  },
  mounted:function(){
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.featured-item{
  text-decoration: none;
  cursor:pointer;
  color:inherit;
  display:block;
  position:relative;
}

.flex-box{
  display:flex;
  justify-content: center;
}
.title{
  flex:1;
}

.text{
  line-height:1.1em;
}

img{
  border-radius:2px;
}

.clear-float{
  clear:both;
}
.poster-image{
  float:left;
  margin-right:10px;
  width:140px;
}
h2{
  margin:0px;
  margin-bottom:10px;
  font-size:1.2em;
  line-height:1em;
}


.lees-meer{
 
 color:#F46767;
 font-weight:bold;
}


</style>

